const state = {};
const mutations = {
  setGlobalParams(state, data) {
    state.globalParams = data.data;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
};
